import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import { KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";

const UserFilter = ({ selectedUserIds, setSelectedUserIds, users }) => {
  const handleChange = (event) => {
    const {
      target: { value },
    } = event;

    if (value?.includes("all") && value?.length > 1) {
      setSelectedUserIds(value?.filter((item) => item !== "all"));
      return;
    }

    if (value?.length === 0) {
      setSelectedUserIds(["all"]);
      return;
    }
    setSelectedUserIds(value);
  };

  return (
    <div>
      <FormControl>
        <Select
          disableUnderline
          multiple
          value={selectedUserIds}
          onChange={handleChange}
          renderValue={(selected) =>
            selected?.includes("all")
              ? "All Users"
              : selected
                  ?.map(
                    (selected) =>
                      users.find((user) => user._id === selected)?.name
                  )
                  .join(", ")
          }
          sx={{
            ".MuiSelect-standard": {
              background: "transparent",
              marginRight: "10px",
            },
            ".MuiSelect-select": {
              color: "#94BA33",
              fontSize: "0.875rem",
              fontWeight: 500,
              padding: "4px 8px",
              backgroundColor: "transparent",
            },
            "&::focus": {
              background: "transparent !important",
            },
            ".MuiSelect-icon": {
              color: "#94BA33",
            },
          }}
          variant="standard"
          IconComponent={KeyboardArrowDownIcon}
        >
          <MenuItem value="all">
            <Checkbox
              checked={selectedUserIds.includes("all")}
              disabled={true}
            />
            <ListItemText primary="All Users" />
          </MenuItem>
          {[...users]
            ?.sort((a, b) => a.name.localeCompare(b.name))
            ?.map((user) => (
              <MenuItem key={user._id} value={user._id}>
                <Checkbox checked={selectedUserIds.includes(user._id)} />
                <ListItemText primary={user.name} />
              </MenuItem>
            ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default UserFilter;
